import React from 'react';

import Conditional from '../../common/conditional';
import CustomCoverForm from '../../forms/custom-fvi/coverForm';
import Modal from '../modal';

import { getCoverData, loadPipingCoverData, setToggleVisible } from '../../../store/coverData';
import { useAppDispatch, useAppSelector } from '../../../store/configureStore';
import { createFVIPipingReportCoverData, updateFVIPipingReportCoverData } from '../../../services/reportService';

import classNames from './style.module.scss';
import toastService from '../../../services/toastService';

import { ExxonMobilFVIPipingCoverData } from '../../../utils/models';
import { getErrorMessage } from '../../../utils/utilities';

interface FVICoverDataProps {
	isVisible: boolean;
	coverDataId: string;
	subtitle: string;
}

const FVICoverData: React.FC<FVICoverDataProps> = ({
	coverDataId,
	isVisible,
	subtitle
}) => {
	const dispatch = useAppDispatch();
	const coverData = useAppSelector(getCoverData);

	const handleFVIPipingDataToggle = () => {
		dispatch(setToggleVisible(!coverData.isFVIPipingVisible));
	};

	const updateCoverData = async (data: ExxonMobilFVIPipingCoverData) => {
		if (coverDataId) await updateFVIPipingReportCoverData(coverDataId, data);
		else await createFVIPipingReportCoverData(data);

		handleFVIPipingDataToggle();
	};

	const handleSaveFVIPipingData = (data: ExxonMobilFVIPipingCoverData) => {
		toastService.promise(updateCoverData(data), {
			loading: 'Save Cover Data',
			success: () => 'Cover Data Saved',
			error: getErrorMessage,
		});
	};

	React.useEffect(() => {
		dispatch(loadPipingCoverData(coverDataId) as any);
	}, [coverDataId, dispatch]);

	return (
		<Conditional isVisible={isVisible}>
			<div className={classNames.coverDataCTA}>
				<div className={classNames.coverDataCTAIcon}>
					<i className="bi bi-clipboard-data-fill"></i>
				</div>

				<div className={classNames.coverDataCTABody}>
					<h3>Update Default Cover Data</h3>
					<p>{subtitle}</p>
				</div>

				<button
					className={classNames.coverDataCTAButton}
					onClick={handleFVIPipingDataToggle}
				>
					Click to update
				</button>
			</div>

			<Modal
				isVisible={coverData.isFVIPipingVisible}
				onClose={handleFVIPipingDataToggle}
			>
				<div className="p-4">
					<CustomCoverForm
						initialData={coverData.fviCoverData}
						onAddCoverForm={handleSaveFVIPipingData}
					/>
				</div>
			</Modal>
		</Conditional>
	);
};

export default FVICoverData;
